import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AffiliateTypeModal } from '../../modals/affiliate-type-modal/affiliate-type-modal.component';
import { ConfirmModal } from '@app/shared/modals';

@Component({
  selector: 'app-company-affiliate-types',
  templateUrl: './company-affiliate-types.component.html',
  styleUrls: ['./company-affiliate-types.component.scss'],
})
export class CompanyAffiliateTypesComponent implements OnInit {
  error: any;
  success: any;
  pending = false;
  FAQs = [];
  companyRecords = [];
  recordsToDisplay = [];
  totalItems = 0;
  rows = 10;
  maxSize = 3;
  currentPage = 1;
  filter = {};
  constructor(
    private location: Location,
    private companyOwnershipService: CompanyOwnershipService,
    private modalService: SuiModalService
  ) {}

  ngOnInit(): void {
    this.getTypes();
    this.companyOwnershipService.newAffiliateTypeAdded.subscribe((res: any) => {
      this.getTypes();
    });
  }

  goBack() {
    this.location.back();
  }

  getTypes() {
    this.pending = true;
    this.companyOwnershipService.getAllOwnershipTypes().subscribe(
      (res: any) => {
        console.log(res);
        this.pending = false;
        this.companyRecords = res;
        this.recordsToDisplay = this.companyRecords;
        this.appendCollapseState();
        this.totalItems = this.companyRecords.length;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );

    this.companyOwnershipService
      .getOwnershipTypes()
      .subscribe((res) => console.log(res));
  }

  searchRecords(event) {
    this.recordsToDisplay = [];
    this.companyRecords.forEach((record) => {
      if (record.companyTypeName.toLowerCase().includes(event)) {
        this.recordsToDisplay.push(record);
      }
    });
    this.totalItems = this.recordsToDisplay.length;
  }

  displayRecords(event) {}

  sortRecords(event) {
    this.recordsToDisplay.reverse();
  }
  removeIndividual(event) {
    console.log(event);
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Affiliate Types?',
          'Are you sure you want to remove affiliate Type?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.companyOwnershipService
          .removeAffiliateTypeFromCompanyType({
            companyTypeHasOwnershipTypeId: event.companyTypeHasOwnershipTypeId,
          })
          .subscribe(
            (res: any) => {
              console.log(res);
              this.pending = false;
              this.success = 'Affiliate successfully removed from Company Type';
              this.getTypes();
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
      })
      .onDeny(() => {});
  }
  nextPage(event) {}

  toggleAffiliateTypesVisibility(index: number) {
    this.companyRecords[index]['isCollapsed'] =
      !this.companyRecords[index]['isCollapsed'];
  }

  addAffiliateType(companyTypeId = '') {
    this.modalService
      .open(new AffiliateTypeModal(companyTypeId, this.companyRecords))
      .onApprove(() => {});
  }

  appendCollapseState() {
    console.log('here', this.companyRecords);

    this.companyRecords.forEach((companyRecord) => {
      companyRecord['isCollapsed'] = true;
    });
  }
}
